import { Component, inject, input } from '@angular/core';
import { CdkMenu, CdkMenuItem, CdkMenuTrigger } from '@angular/cdk/menu';
import { Store } from '@ngrx/store';
import { TranslatePipe } from '@ngx-translate/core';

import * as fromAuth from '@app/modules/authentication/store/auth';
import { AppHeaderTheme } from '../../app-header-theme.model';

@Component({
  selector: 'topo-app-help',
  imports: [CdkMenuTrigger, CdkMenu, CdkMenuItem, TranslatePipe],
  templateUrl: './app-help.component.html',
  styleUrl: '../app-header-button.scss'
})
export class AppHelpComponent {
  theme = input<AppHeaderTheme>(AppHeaderTheme.Default);
  protected isActive = false;
  private store = inject(Store);

  goToZendeskKnowledgeBase(): void {
    this.store.dispatch(fromAuth.getZendeskSso());
  }

  goToLitmosTraining(): void {
    this.store.dispatch(fromAuth.getLitmosSso());
  }
}
